// extracted by mini-css-extract-plugin
export default {"about":"About_about__Oq1Kg","about__content":"About_about__content__WlD+J","about__image":"About_about__image__wiEfX"};